import axios from 'axios';

const ProjectID = (localStorage.getItem('selectedProject')) ? localStorage.getItem('selectedProject') : '';
class Api {
	constructor() {
		this.instance = axios.create({
			baseURL: process.env.REACT_APP_API_URL,
			timeout: 300000000
		});
	}
	get(url) {
		// this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('onevubasicauthtoken');
		this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('refreshToken');
		this.instance.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
		this.instance.defaults.headers.common['Accept'] = 'application/json';
		this.instance.defaults.headers.common['ProjectID'] = ProjectID;
		return this.instance.get(url);
	}
	post(url, data) {
		// this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('onevubasicauthtoken');

		this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('refreshToken');

		this.instance.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
		this.instance.defaults.headers.common['Accept'] = 'application/json';
		this.instance.defaults.headers.common['ProjectID'] = ProjectID;
		return this.instance.post(url, data);
	}
	put(url, data) {
		// this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('onevubasicauthtoken');

		this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('refreshToken');

		this.instance.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
		this.instance.defaults.headers.common['Accept'] = 'application/json';
		this.instance.defaults.headers.common['ProjectID'] = ProjectID;
		return this.instance.put(url, data);
	}
	delete(url, data) {
		// this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('onevubasicauthtoken');

		this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('refreshToken');

		this.instance.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
		this.instance.defaults.headers.common['Accept'] = 'application/json';
		this.instance.defaults.headers.common['ProjectID'] = ProjectID;
		return this.instance.delete(url, data);
	}
	patch(url, data) {
		// this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('onevubasicauthtoken');

		this.instance.defaults.headers.common['Authorization'] = localStorage.getItem('refreshToken');

		this.instance.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
		this.instance.defaults.headers.common['Accept'] = 'application/json';
		this.instance.defaults.headers.common['ProjectID'] = ProjectID;
		return this.instance.patch(url, data);
	}
}

const api = new Api();

export { api };
